import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { Route } from "../../Routers/RouteList";
import { dynamicImage, Image } from "../../Utils";
import PageImage from "../CommonComponents/PageImage";

const Error404 = () => {
  return (
    <section className="error-main">
      <PageImage />
      <Container className="position-relative">
        <Row>
          <Col xs="12" lg="6">
            <div className="error-images">
              <Image className="img-fluid" src={dynamicImage("error/1.png")} alt="footer-back-img" />
            </div>
          </Col>
          <Col xs="12" lg="6">
            <div className="error-contain">
              <h1>{"404"}</h1>
              <h2>{"Page Not Found"}</h2>
              <h4>{"The Page You Are Attempting To Reach Is Not Available. "}<br />{"This May Be Because The Page Does Not Exist Or Has Been Moved."}</h4>
              <Link className="btn btn-primary" to={Route.Messenger}>{"back to home"}</Link>
              <div className="animated-bg"><i /><i /><i /></div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Error404;
